
import {ContentsModal} from "modals/ContentsModal";

export function handleContentsModal() {
    $("body").on('click', '.js-content-btn', function () {
        setContentsModal($(".js-article-content-list .js-content-list").clone());
    })
}

function setContentsModal(list) {
    let modal = new ContentsModal(list);

    $(window).on('resize', function () {
        if ($(window).outerWidth() >= 760) {
            modal.close();
        }
    });

    if ($(window).outerWidth() < 760) {
        modal.show()
        return false;
    }
}
